import { render, staticRenderFns } from "./OrderReport.vue?vue&type=template&id=f3ec37ec&"
import script from "./OrderReport.vue?vue&type=script&lang=ts&"
export * from "./OrderReport.vue?vue&type=script&lang=ts&"
import style0 from "./OrderReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports